<template>
  <!--编辑半成品-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading='loading' type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      data: {
        name: '', // 型号
        content: '', // 含量
        describe: '', // 描述
        price: null // 价格
      },
      options: [
        {
          name: 'name',
          note: '型号',
          type: 'String',
          validators: [
            (val) => val ? null : '型号不可为空'
          ]
        },
        {
          name: 'content',
          note: '含量',
          type: 'String',
          validators: [
            (val) => val ? null : '含量不可为空'
          ]
        },
        {
          name: 'describe',
          note: '描述',
          type: 'String'
        },
        {
          name: 'price',
          note: '价格',
          type: 'Number',
          disabled: true
        }
      ]
    }
  },
  async mounted () {
    if (this.modelId) { this.data.model = this.modelId }
    if (this.workShop) { this.data.workShop = this.workShop }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async submit () {
      // 验证必填项
      let erros = await this.$refs.input.validate()
      if (Object.keys(erros).length) return
      // 确保名称不相同
      this.loading = !this.loading
      const { data: res } = await this.$tkParse.get('/classes/parts', {
        params: {
          where: {
            name: this.data.name
          }
        }
      })
      if (res.results.length > 0) {
        this.loading = !this.loading
        throw this.$notification.error({
          message: '保存失败',
          description: '半成品型号已存在，请修改型号'
        })
      }
      await this.$modelAjax.post('parts', this.data).catch(e => {
        this.loading = !this.loading
        throw this.$notification['error']({
          message: '保存失败',
          description: '保存失败，请重新尝试'
        })
      })
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    vm: null,
    title: String,
    modelId: null,
    workShop: null
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
</style>
